var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    { attrs: { size: "small", "label-width": "120px" } },
    [
      _c(
        "el-form-item",
        { attrs: { label: "挂号费用" } },
        [
          _c("el-input-number", {
            attrs: {
              precision: 2,
              placeholder: "请输入挂号费用",
              disabled: "",
            },
            model: {
              value: _vm.pageData.activeDiagRecord.diagRecord["enrollAmount"],
              callback: function ($$v) {
                _vm.$set(
                  _vm.pageData.activeDiagRecord.diagRecord,
                  "enrollAmount",
                  $$v
                )
              },
              expression:
                "pageData.activeDiagRecord.diagRecord['enrollAmount']",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "加工费用" } },
        [
          _c("el-input-number", {
            attrs: {
              precision: 2,
              placeholder: "请输入加工费用",
              disabled: "",
            },
            model: {
              value: _vm.pageData.activeDiagRecord.diagRecord["decoctPrice"],
              callback: function ($$v) {
                _vm.$set(
                  _vm.pageData.activeDiagRecord.diagRecord,
                  "decoctPrice",
                  $$v
                )
              },
              expression: "pageData.activeDiagRecord.diagRecord['decoctPrice']",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "理疗费用" } },
        [
          _c("el-input-number", {
            attrs: {
              precision: 2,
              placeholder: "请输入理疗费用",
              disabled: "",
            },
            model: {
              value: _vm.pageData.activeDiagRecord.diagRecord["serveAmount"],
              callback: function ($$v) {
                _vm.$set(
                  _vm.pageData.activeDiagRecord.diagRecord,
                  "serveAmount",
                  $$v
                )
              },
              expression: "pageData.activeDiagRecord.diagRecord['serveAmount']",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "饮片费用" } },
        [
          _c("el-input-number", {
            attrs: {
              precision: 2,
              placeholder: "请输入饮片费用",
              disabled: "",
            },
            model: {
              value: _vm.pageData.activeDiagRecord.diagRecord["chmedAmount"],
              callback: function ($$v) {
                _vm.$set(
                  _vm.pageData.activeDiagRecord.diagRecord,
                  "chmedAmount",
                  $$v
                )
              },
              expression: "pageData.activeDiagRecord.diagRecord['chmedAmount']",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "中成药费用" } },
        [
          _c("el-input-number", {
            attrs: {
              precision: 2,
              placeholder: "请输入中成药费用",
              disabled: "",
            },
            model: {
              value: _vm.pageData.activeDiagRecord.diagRecord["medAmount"],
              callback: function ($$v) {
                _vm.$set(
                  _vm.pageData.activeDiagRecord.diagRecord,
                  "medAmount",
                  $$v
                )
              },
              expression: "pageData.activeDiagRecord.diagRecord['medAmount']",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "代煎费用" } },
        [
          _c("el-input-number", {
            attrs: {
              precision: 2,
              placeholder: "请输入代煎费用",
              disabled: "",
            },
            model: {
              value: _vm.pageData.activeDiagRecord.diagRecord["chagentAmount"],
              callback: function ($$v) {
                _vm.$set(
                  _vm.pageData.activeDiagRecord.diagRecord,
                  "chagentAmount",
                  $$v
                )
              },
              expression:
                "pageData.activeDiagRecord.diagRecord['chagentAmount']",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "代售费用" } },
        [
          _c("el-input-number", {
            attrs: {
              precision: 2,
              placeholder: "请输入代售费用",
              disabled: "",
            },
            model: {
              value: _vm.pageData.activeDiagRecord.diagRecord["agentAmount"],
              callback: function ($$v) {
                _vm.$set(
                  _vm.pageData.activeDiagRecord.diagRecord,
                  "agentAmount",
                  $$v
                )
              },
              expression: "pageData.activeDiagRecord.diagRecord['agentAmount']",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "总费用" } },
        [
          _c("el-input-number", {
            attrs: { precision: 2, placeholder: "请输入总费用", disabled: "" },
            model: {
              value: _vm.pageData.activeDiagRecord.diagRecord["sellingAmount"],
              callback: function ($$v) {
                _vm.$set(
                  _vm.pageData.activeDiagRecord.diagRecord,
                  "sellingAmount",
                  $$v
                )
              },
              expression:
                "pageData.activeDiagRecord.diagRecord['sellingAmount']",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }